import React from "react";
import { useT } from "@/lib/i18n";

// Split-screen auth layout: brand/imagery left, form card right.
export default function AuthLayout({ children }) {
  const { t } = useT();
  return (
    <div className="min-h-screen w-full lg:grid lg:grid-cols-[1.1fr_1fr] bg-background">
      {/* Brand panel */}
      <div className="relative hidden lg:flex flex-col justify-between overflow-hidden bg-[#0D1B2A] p-12">
        <img
          src="https://images.unsplash.com/photo-1769450290445-3daed0c8fe63?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400"
          alt="Excursion quad dans le désert"
          className="absolute inset-0 h-full w-full object-cover opacity-25"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0D1B2A] via-[#0D1B2A]/70 to-[#0D1B2A]/40" />
        <div className="relative z-10 flex items-center gap-2.5">
          <img src="/actipilote-symbol.png" alt="ActiPilote" className="h-11 w-11 object-contain" />
          <span className="text-lg font-bold tracking-tight"><span className="text-white">Acti</span><span className="text-[#2563EB]">Pilote</span></span>
        </div>
        <div className="relative z-10 max-w-md">
          <p className="text-2xl font-semibold leading-snug text-white">
            Pilotez vos excursions, votre caisse et votre flotte depuis une seule plateforme.
          </p>
          <div className="mt-8 flex gap-8">
            <div>
              <p className="font-mono text-3xl font-bold text-white">+40%</p>
              <p className="text-sm text-slate-300">de temps administratif gagné</p>
            </div>
            <div>
              <p className="font-mono text-3xl font-bold text-white">100%</p>
              <p className="text-sm text-slate-300">de visibilité sur vos revenus</p>
            </div>
          </div>
        </div>
        <p className="relative z-10 text-xs text-slate-400">{t("app.tagline")}</p>
      </div>

      {/* Form panel */}
      <div className="flex min-h-screen items-center justify-center px-6 py-12">
        <div className="w-full max-w-sm animate-fade-up">
          <div className="mb-8 flex items-center gap-2.5 lg:hidden">
            <img src="/actipilote-logo.png" alt="ActiPilote" className="h-8" />
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
